import { createSlice } from "@reduxjs/toolkit";
import { getItem, getJson, setJson } from "utils/safeStorage";

const DEFAULT_VARTA = {
  active: false,
  showwarning: false,
};

export const initialState = {
  currentRouteKey: "",
  currentReport: "",
  onboard: getItem("onboard") === "true",
  onboardReplayKey: 0,
  // Modül seviyesinde çalışır: ham JSON.parse burada throw ederse (bozuk kayıt
  // veya storage erişimi kapalı) tüm uygulama import aşamasında ölür.
  varta: getJson("varta", DEFAULT_VARTA),
  whitelabel: {
    loaded: false,
    active: false,
    company: null,
    config: null,
  },
};

export const commonSlice = createSlice({
  name: "base/common",
  initialState,
  reducers: {
    setCurrentRouteKey: (state, action) => {
      state.currentRouteKey = action.payload;
    },
    setCurrentReport: (state, action) => {
      state.currentReport = action.payload;
    },
    setOnboard: (state, action) => {
      state.onboard = action.payload;
    },
    replayOnboard: (state) => {
      state.onboard = false;
      state.onboardReplayKey += 1;
    },
    setVarta: (state, action) => {
      const payload = action.payload ?? DEFAULT_VARTA;
      state.varta = payload;
      // JSON.stringify(undefined) "undefined" string'i yazıyordu; sonraki
      // açılışta JSON.parse patlıyor ve kullanıcı kalıcı beyaz ekranda kalıyordu.
      setJson("varta", payload);
    },
    setWhitelabel: (state, action) => {
      state.whitelabel = {
        ...state.whitelabel,
        ...action.payload,
      };
    },
  },
});

export const {
  setCurrentRouteKey,
  setCurrentReport,
  setOnboard,
  replayOnboard,
  setVarta,
  setWhitelabel,
} = commonSlice.actions;

export default commonSlice.reducer;
